<script setup lang="ts">
defineProps<{
  codeDegrades: Array<{}>;
}>();
</script>
<template>
  <m-banner
    expanded
    type="danger"
    :count="codeDegrades.length"
    label="Warning"
    class="safety-alert-banner"
  >
    <ul class="code-degrade-list">
      <li
        v-for="(codeDegrade, index) in codeDegrades"
        :key="`code_degrade${index}`"
        data-testid="code_degrade"
      >
        <div v-if="codeDegrade.message">{{ codeDegrade.message }}</div>
        <div
          v-if="codeDegrade?.codes?.length"
          class="code-degrades"
          style="list-style-type: disc; margin-left: 1.5rem"
          role="generic"
        >
          <p v-for="code in codeDegrade.codes" :key="code" style="display: list-item">{{ code }}</p>
        </div>
      </li>
    </ul>
  </m-banner>
</template>
<style lang="scss">
// ENG-21423 beats DrugAlertDisplay's `.safety-alert-banner ul` on specificity
.safety-alert-banner ul.code-degrade-list {
  padding-right: 16px;
  padding-inline-start: 0px;
  list-style: none;

  li {
    line-height: 1.4;
  }

  li + li {
    margin-top: var(--gap-2);
  }
}
</style>
